import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import TeamsTreeView from "../../teams/teamsTreeView";
import { Scrollbars } from 'react-custom-scrollbars';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';

@inject('addEditUserStore', 'teamsStore', 'addEditUserStore') @observer
export default class UserFormTeamsUnits extends Component {

    handleChangeTeamIds = e => this.props.addEditUserStore.setTeamIds(e.target.value);
    
    checkedHandler = (checkedKeys) => {

        this.props.addEditUserStore.setTeamIds(checkedKeys.checked);
    }

    render(){
        
        if (this.props.teamsStore.teams == null) {
          
            return null;
        }

        return (
            <div className='add-user-form-wrapper'>
                <div className='general-form-wrapper'>
                    <ValidationTopErrorMessage errorMessage={this.props.addEditUserStore.addUserErrorMessage} />
                    <Scrollbars style={{ height: '38vh' }} className='user-form-organizations-scrolls'>
                        <TeamsTreeView 
                            teams={this.props.teamsStore.teams}
                            checkedKeys={this.props.addEditUserStore.values.teamIds.map(String)}
                            checkedHandler={this.checkedHandler}
                            checkable={true}
                            selectable={false}
                            checkStrictly={true} />
                    </Scrollbars>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/users/addEditUser/userFormTeamsUnits.jsx